import {isJwtExpired} from "jwt-check-expiration";
import { jwtDecode } from "jwt-decode";

export const checkToken = (token) => {
    try {
        return isJwtExpired(token);
    } catch (error) {
        return true;
    }
}

export const checkRole = (token) => {
    try {
        const decoded = jwtDecode(token);
        console.log(decoded)
        const roles = decoded.authorities || [];
        return roles.includes("ROLE_ADMIN");
    } catch (error) {
        return true;
    }
}